import React, { useEffect } from 'react';
import BootstrapTable from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2';
import filterFactory from '../../../../components/react-bootstrap-table-next/react-bootstrap-table2-filter';
import './BuyersSelectionStage.scss';
import { ColumnConfig } from './ColumnTemplates/ColumnTemplate';
import PortalTooltip from '../../../../components/PortalTooltip/PortalTooltip';

interface TableComponentProps {
    title: string;
    color: string;
    columns?: ColumnConfig[];
    data?: any[];
    startDate?: Date;
    endDate?: Date;
    hideHeaderContent?: boolean;
}

const BuyersSelectionStage = (props: TableComponentProps) => {
    useEffect(() => {
        adjustHeaderHeights();

        window.addEventListener('resize', adjustHeaderHeights);

        return () => {
            window.removeEventListener('resize', adjustHeaderHeights);
        };
    }, [props.data, props.columns]);

    const adjustHeaderHeights = () => {
        const headerCells = document.querySelectorAll('.custom-header-cell');
        let maxHeight = 0;

        headerCells.forEach((cell) => {
            const height = (cell as HTMLElement).offsetHeight;
            if (height > maxHeight) {
                maxHeight = height;
            }
        });

        headerCells.forEach((cell) => {
            (cell as HTMLElement).style.height = `${maxHeight}px`;
        });
    };

    const formatDate = (date: Date) =>
        `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`;

    return (
        <div className="buyers-selection-stage-container">
            <div
                className="buyers-selection-stage-header"
                style={
                    { '--stage-header-bg': props.color } as React.CSSProperties
                }>
                {props.hideHeaderContent ? (
                    <>
                        <div className="buyers-selection-stage-title-daterange">
                            <div className="buyers-selection-stage-title">
                                <span className="invisible">.</span>
                            </div>
                            <div className="date-range-container">
                                <div className="date-labels-empty">
                                    <span className="invisible">.</span>
                                </div>
                                <div className="date-values-emtpy">
                                    <span className="invisible">.</span>
                                </div>
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        <div className="buyers-selection-stage-title-daterange">
                            <div className="buyers-selection-stage-title">
                                {props.title}
                            </div>

                            <div className="date-range-container">
                                <div>
                                    Start Date: {formatDate(props.startDate)}
                                </div>
                                <div>End Date: {formatDate(props.endDate)}</div>
                            </div>
                        </div>
                        {!(props.columns && props.columns.length > 0) ? (
                            <div className="empty-div"></div>
                        ) : (
                            <></>
                        )}
                    </>
                )}
            </div>
            {props.columns && props.columns.length > 0 ? (
                <div
                    className="table-wrapper"
                    style={
                        {
                            '--table-header-color': props.color,
                            '--table-row-color': props.color,
                        } as React.CSSProperties
                    }>
                    <BootstrapTable
                        bootstrap4
                        keyField="id"
                        data={props.data ?? []}
                        columns={props.columns.map((col) => ({
                            ...col,
                            headerFormatter: (column) => (
                                <div className="custom-header-cell">
                                    <span id={col.id}>{column.text}</span>
                                    <PortalTooltip
                                        anchorId={col.id}
                                        delayShow={0}
                                        place="top"
                                        content={column.text}
                                    />
                                </div>
                            ),
                            formatter:
                                col.formatter != null
                                    ? col.formatter
                                    : (cell: any, row: any) => {
                                          if (col.component) {
                                              const ColumnComponent =
                                                  col.component;
                                              return (
                                                  <ColumnComponent
                                                      value={cell}
                                                      action={col.action}
                                                      readonly={col.readonly}
                                                      row={row}
                                                      actionParameter={
                                                          col.actionParameter
                                                      }
                                                  />
                                              );
                                          }
                                          return cell;
                                      },
                        }))}
                        headerClasses="custom-header"
                        rowClasses={'custom-row'}
                        filter={filterFactory()}
                        noDataIndication=""
                    />
                </div>
            ) : (
                <div>
                    <p className="empty-table" />
                </div>
            )}
        </div>
    );
};

export default BuyersSelectionStage;
